import { BaseCard } from '@bnnvara/cards';
import PropTypes from 'prop-types';
import React from 'react';

export const InfoCard = ({ title, image }) => {
  const newImage = image.url.replace('w_1250', 'w_650');

  return (
    <BaseCard
      title={title}
      backgroundImage={newImage}
      titleSizeLg="28px"
      wide
    />
  );
};

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default InfoCard;
